import { render } from "./UsersAdmin.vue?vue&type=template&id=05d82a5c"
import script from "./UsersAdmin.vue?vue&type=script&lang=js"
export * from "./UsersAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__